// extracted by mini-css-extract-plugin
export default {"title_wrapper":"StoreDialog_title_wrapper__O3Ysq","api_key":"StoreDialog_api_key__+HW9V","copy_tip":"StoreDialog_copy_tip__uj6s7"};